import React from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import './Layout.css';

const ChevronIcon = () => (
  <svg width="16px" height="16px" strokeWidth="1.4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="currentColor">
    <path d="M9 6L15 12L9 18" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"></path>
  </svg>
);

const Layout = ({ user, onLogout, children }) => {
  const location = useLocation();

  const getBreadcrumbs = () => {
    const path = location.pathname;
    const segments = path.split('/').filter(Boolean);

    const breadcrumbMap = {
      'dashboard': 'Dashboard',
      'users': 'Users',
      'knowledgebase': 'Knowledgebase',
      'masters': 'Masters',
      'specialities': 'Specialities',
      'sub-specialities': 'Sub Specialities',
      'question-types': 'Question Types'
    };

    if (segments.length === 0 || segments[0] === 'dashboard') {
      return ['Dashboard'];
    }

    return segments.map(seg => breadcrumbMap[seg] || seg);
  };

  const breadcrumbs = getBreadcrumbs();

  return (
    <div className="layout-container">
      <Sidebar onLogout={onLogout} />

      <div className="main-content">
        <nav className="top-navbar">
          <div className="navbar-left">
            <div className="breadcrumbs">
              {breadcrumbs.map((crumb, index) => (
                <span key={index} className="breadcrumb-item">
                  {index > 0 && <span className="breadcrumb-separator"><ChevronIcon /></span>}
                  <span className={index === breadcrumbs.length - 1 ? 'active' : ''}>
                    {crumb}
                  </span>
                </span>
              ))}
            </div>
          </div>
          <div className="navbar-right">
            <span className="user-name">Welcome, {user?.name || 'Admin'}</span>
          </div>
        </nav>

        <div className="content-area">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Layout;
